import { FETCH_COUPONS_FAILURE, FETCH_COUPONS_REQUEST, FETCH_COUPONS_SUCCESS } from '../../actionTypes';
import { FAILURE, FETCHING, SUCCESS } from '../../fetchStatus';

const initialState = null;

export default function coupons(state = initialState, action) {
    switch (action.type) {
        case FETCH_COUPONS_REQUEST:
            return {
                status: FETCHING,
            };
        case FETCH_COUPONS_SUCCESS:
            return {
                status: SUCCESS,
                data: action.payload.coupons,
            };
        case FETCH_COUPONS_FAILURE:
            return {
                status: FAILURE,
                error: action.payload.error,
            };
        default:
            return state;
    }
}
